// extracted by mini-css-extract-plugin
export default {"teacherInfo":"TeacherInfo_teacherInfo__DskKG","sep":"TeacherInfo_sep__GBZH9"};